import { checkMobile } from "../util/globals";
import DesktopSiteView from "./DesktopSiteView";
import MobileSiteView from "./MobileSiteView";

function SiteDetails({ site, user }) {
	if (!site || site?.idNo === "all") {
		return <NoSite />;
	} else {
		if (checkMobile()) {
			return <MobileSiteView site={site} user={user} />;
		} else {
			return <DesktopSiteView site={site} user={user} />;
		}
	}
}

function NoSite() {
	return <div id="site-details-no-site">Select a site to view details.</div>;
}

export default SiteDetails;
